import styled from 'styled-components'
import {
  textStyleSizeOptions,
  textStyleSizeStyleOptions,
  textStyleWeightOptions,
  textStyleWeightStyleOptions
} from '../stories/fundamentals/text-styles/constants'
import colorsOptions from '../stories/fundamentals/colors-styles/constants'

export const RecursiveListContainer = styled.div`
  width: 100%;
  position: relative;
`

export const RecursiveListItem = styled.div`
  width: 100%
  padding: 0 0.5rem;
`

export const LoadContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ConfirmIconContainer = styled.div`
  padding: 0.5rem 1rem 0.5rem 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const IconListIsOpen = styled.div`
  padding: 0.25rem;
  transform: rotate(${({ isOpen }) => (isOpen ? '180' : '0')}deg);
  transition: transform 0.2s;
`

export const RecursiveLisTrigger = styled.div`
  cursor: pointer;
`

// item
export const RecursiveItemOption = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  width: 100%;
  cursor: pointer;

  &:hover {
    background: ${colorsOptions.greys['grey-05']};
  }

  &:active {
    background: ${colorsOptions.greys['grey-10']};
  }

  ${({ isSelected = false }) =>
    isSelected &&
    `
    background: ${colorsOptions.greys['grey-05']};
  `}
`

export const RecursiveItemIcon = styled.span`
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const RecursiveItemLabel = styled.span`
  width: 100%;
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  color: ${({ color }) => color ?? colorsOptions.greys['grey-100']};

  ${({ isSelected = false }) =>
    isSelected
      ? textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]
      : textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]}
`

// search
export const SearchContainer = styled.div`
  background-color: ${colorsOptions.greys.white};
  top: 0;
  position: sticky;
  width: 100%;
  z-index: 3;
`
